
import PropTypes from 'prop-types'
import React from 'react'
import Banner from './Banner'
import ShowHide from './ShowHide'
import getProp from '@f/get-prop'
import { findBanner, adminModeBanner } from './checks'

const notificationBannerShown = trackNotificationBanner.bind(null, 'Shown')
const notificationBannerClicked = trackNotificationBanner.bind(null, 'Clicked')

const AppNotifications = props => {
  const { workspace = {}, billing, billingCount, user } = props

  const banner = findBanner({
    workspaceSlug: workspace.slug,
    billing,
    billingCount
  })

  const adminmodeBanner = adminModeBanner({
    user,
    owners: workspace.owners
  })

  return (
    <div>
      <ShowHide show={isAdminModeAndNotOwner(user, workspace.owners)}>
        <Banner
          {...adminmodeBanner}
          size={'small'} />
      </ShowHide>
      <ShowHide show={banner}>
        <Banner
          {...banner}
          onMount={notificationBannerShown}
          onClick={() => {
            notificationBannerClicked(banner)
            // Redirect after tracking click
            setTimeout(() => (window.location = banner.buttonPath))
          }} />
      </ShowHide>
    </div>
  )
}

function isAdminModeAndNotOwner (user, owners) {
  if (!user.isAdmin) return false
  for (let i = 0; i < owners.length; i++) {
    if (owners[i] === user.id) return false
  }
  return true
}

function trackNotificationBanner (action, { importance, violation, cta }) {
  if (!action) return

  const workspace = getProp('segment.workspace', window)
  let data = { importance, violation, cta }

  if (workspace) {
    data.workspace_id = workspace.id
    data.workspace_slug = workspace.slug
  }

  window.analytics.track(`Notification Banner ${action}`, data)
}

AppNotifications.defaultProps = {
  workspace: {}
}

AppNotifications.propTypes = {
  workspace: PropTypes.object.isRequired,
  billing: PropTypes.object.isRequired,
  billingCount: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired
}

AppNotifications.displayName = 'AppNotifications'

export default AppNotifications



// WEBPACK FOOTER //
// ./ui/AppNotifications.js